import React from 'react'

import { useTheme } from '@/hooks/useTheme'

interface CursorProps {
  cx: number
  cy: number
  color: string
}

const CURSOR_SIZE = 16
const CURSOR_RADIUS = CURSOR_SIZE / 2
const CURSOR_INTERNAL_SIZE = CURSOR_SIZE - 6

export const Cursor: React.FC<CursorProps> = ({ cx, cy, color }) => {
  const theme = useTheme()

  return (
    <div
      style={{
        position: 'absolute',
        left: `${cx - CURSOR_RADIUS}px`,
        top: `${cy - CURSOR_RADIUS}px`,
        width: `${CURSOR_SIZE}px`,
        height: `${CURSOR_SIZE}px`,
        borderRadius: '50%',
        backgroundColor: color,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        pointerEvents: 'none',
        zIndex: 999,
      }}
    >
      <div
        style={{
          width: `${CURSOR_INTERNAL_SIZE}px`,
          height: `${CURSOR_INTERNAL_SIZE}px`,
          borderRadius: '50%',
          backgroundColor: theme.colors.background.screen,
        }}
      />
    </div>
  )
}
